<template>
  <div id="company-owner-data-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">DADOS DO RESPONSÁVEL LEGAL</h2>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <form class="panel__content needs-validation">

          <div class="row">
            <p class="col-12 col-sm-6">
              <input :class="{ 'input': true, 'is-invalid': errors.has('nome') }" name="nome"
                v-validate="'required|alpha_spaces'" type="text" class="form-control" v-model="user.nome" id="nome"
                placeholder="Nome: João Paulo" value="">
              <span class="invalid-feedback">
                {{ errors.first('nome') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input :class="{ 'input': true, 'is-invalid': errors.has('sobrenome') }" name="sobrenome"
                v-validate="'required|alpha_spaces'" type="text" class="form-control" v-model="user.sobrenome" id="sobrenome"
                placeholder="Sobrenome: da Silva" value="">
              <span class="invalid-feedback">
                {{ errors.first('sobrenome') }}
              </span>
            </p>
          </div>


          <div class="row">
            <p class="col-12 col-sm-6">

              <masked-input v-validate="'required|cpf'" type="text" name="cpf" class="form-control"
                :class="{ 'is-invalid': errors.has('cpf') }" v-model="user.cpf"
                :mask="[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask" :guide="false" placeholder="CPF: 000.000.000-00">
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first('cpf') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">

              <masked-input v-validate="'required|datanasc'" type="text" name="datanascimento" class="form-control"
                :class="{ 'is-invalid': errors.has('datanascimento') }" v-model="user.datanascimento"
                :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]" v-on:keydown.delete="onDeleteMask"
                :guide="false" placeholder="Data de Nascimento: DD/MM/AAAA">
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first('datanascimento') }}
              </span>

            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-6">
              <masked-input v-validate="'required|min:16'" type="text" name="celular" class="form-control"
                :class="{ 'is-invalid': errors.has('celular') }" v-model="user.celular"
                :mask="['(', /\d/, /\d/, ')', ' ', /\d/, '.', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask" :guide="false" placeholder="Celular: ">
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first('celular') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <select class="form-control" v-validate="'required'" v-model="user.sexo"
                :class="{ 'is-invalid': errors.has('sexo') }" name="sexo">
                <option value="" selected disabled>Sexo:</option>
                @if ($plano['somente_feminino'] == 'N')
                <option value="M">Masculino</option>
                @endif
                <option value="F">Feminino</option>
              </select>

              <span class="invalid-feedback">
                {{ errors.first('sexo') }}
              </span>
            </p>
          </div>

          <h4 class="panel__title">DADOS DE ACESSO</h4>

          <div class="row">
            <p class="col">
              <input :class="{ 'input': true, 'is-invalid': errors.has('email') }" name="email" class="form-control"
                v-validate="'required|email'" v-model="user.email" id="email" placeholder="E-mail:"
                value="">
              <span class="invalid-feedback">
                {{ errors.first('email') }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-6">
              <input data-vv-as="senha" v-model="user.password" :class="{ 'is-invalid': errors.has('password') }"
                v-validate="'required|min:6|confirmed:password_confirm'" name="password" type="password"
                class="form-control" placeholder="Cria sua senha:">

              <span class="invalid-feedback">
                {{ errors.first('password') }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <input data-vv-as="confirme sua senha" v-model="user.password_confirm"
                :class="{ 'is-invalid': errors.has('password_confirm') || errors.has('password') }"
                v-validate="'required'" name="password_confirm" ref="password_confirm" type="password"
                class="form-control" placeholder="Confirme sua senha:">

              <span class="invalid-feedback">
                {{ errors.first('password_confirm') }}
              </span>
            </p>
          </div>
          <div class="row">

            <div class="col-12 ps-5 pt-5">
              <p>
                <input data-vv-as="termos de contrato" v-model="user.termoscontrato"
                  :class="{ 'is-invalid': errors.has('termoscontrato') }" v-validate="'required'" name="termoscontrato"
                  type="checkbox" class="form-check-input" />
                Li e aceito os <a href="#" data-toggle="modal" style="color: blue"
                  data-target="#termosdecontratoModal">termos de contrato</a> do programa.
                <span class="invalid-feedback">
                  {{ errors.first('termoscontrato') }}
                </span>
              </p>
              <p>
                <input v-model="user.receberinfo" name="receberinfo" type="checkbox" class="form-check-input"
                  checked="checked" /> Aceito receber informativos do programa via e-mail e Whatsapp.
              </p>
            </div>

          </div>

          <div class="row">

            <div class="col-12">
              <b-alert variant="danger" dismissible :show="showDismissibleAlert" v-model="showDismissibleAlert">

                <div>
                  {{ showMensagemAlert }}
                </div>

              </b-alert>
            </div>

          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import recaptcha from '../../plugins/recaptcha';

export default Vue.extend({
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    clube: {
      required: true,
      type: Object
    },
  },
  methods: {
    async submit() {
      const result = await this.$validator.validateAll([
        'nome',
        'sobrenome',
        'email',
        'cpf',
        'datanascimento',
        'celular',
        'sexo',
        'password',
        'password_confirm',
        'termoscontrato'
      ]);

      try {
        if (await result) {
          return await this.store();
        } else {
          throw new Error('Preencha os campos corretamente');
        }
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    async store() {
      try {
        const token = await recaptcha()

        const response = await axios.post('/cadastro/dados-pessoais', {
          ...this.user,
          token,
          plano: this.plano
        })
        
        if(response.data.error && !response.data.usuario) {
          this.error.show = true
          this.error.text = response.data.message
          return false
        } else {
          this.user.id = response.data.data.id
          return true
        }
      } catch (error) {
        this.error.show = true
        
        if (typeof error.response.data.errors.cpf[0] !== 'undefined') {
          this.error.text = this.$t("CPF já consta na base de dados.")
        } else if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.text = this.$t("E-mail já consta na base de dados.")
        } else {
          this.error.text = this.$t("Erro interno, tente novamente mais tarde.")
        }
        
        return false
      }
    }
  }
})
</script>